import {
    NinchatActionType,
    NinchatRequestAudienceAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'


const actionTypePrefix = 'NINCHAT/action'

export const requestAudience = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatRequestAudienceAction}`,
    async (arg: NinchatActionParams<NinchatRequestAudienceAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatRequestAudienceAction
        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
